import { createLoadingSpinner } from '@vfde-brix/ws10/loading-spinner';
import { HtmlId } from '../enums/elementId';
import { createComponentById } from '@vfde-brix/ws10/core';

/**
 * Creates a Brix Loading Spinner component.
 * @param id Wrapper ID of the loading spinner element.
 * @param nested Option to place the loading spinner as a nested
 * child element inside a block/parent container (default=false).
 * @returns WS10 Loading Spinner component or null
 * if the element with the given ID is not found.
 */
export const mountLoadingSpinner = (id: HtmlId, nested = false) =>
    createComponentById(createLoadingSpinner, id, {
        optNested: nested,
        optSize: 'medium',
        business: {},
    });
